const AttributesFilters = [
    "Color",
    "Fabric",
    "Hand",
    "Material",
    "Artwork",
    "Artist",
    "Effect",
    "Techniques",
    "Era",
]

export default function calculateChipData(Filters, filterAutofIllData){
    let chipData = []

    //primary
    if (Filters.Status !== "") {
        chipData.push({type: "Status", label: Filters.Status})
    }
    if (Filters.cdnullorzero___first_approved_on) {
        chipData.push({type: "cdnullorzero___first_approved_on", label: "Yet to be: Approved"})
    }
    if (Filters.Search !== "") {
        chipData.push({type: "Search", label: Filters.Search})
    }

    //attributes
    AttributesFilters.forEach((attr) => {
        Filters[attr].forEach((item) => {chipData.push({type: attr, label: item, prefix:"EXCLUDE: "})})
    })

    //location
    if (Filters.subquery___amal_sharing___fk_client___fk_card___id !== "") {
        const sharedWith = filterAutofIllData.SharedWithCliend.find((item) => {
            return item.id === Filters.subquery___amal_sharing___fk_client___fk_card___id
        })

        if (sharedWith){
            chipData.push({type: "subquery___amal_sharing___fk_client___fk_card___id", label: sharedWith.name, id: sharedWith.id})
        }
    }

    if (Filters.containsany___location_id?.length > 0) {
        for (let locationF of Filters.containsany___location_id) {
            const Location = filterAutofIllData.Location.find((item) => {
                return item.id === locationF
            })

            if (Location){
                chipData.push({type: "containsany___location_id", label: Location.label, id: Location.id})
            }
        }
    }
    if (Filters.equalto___handed_over_to_userid !== "") {
        const handedTo = filterAutofIllData.HandedOverToClients.find((item) => {
            return item.id === Filters.equalto___handed_over_to_userid
        })

        if (handedTo){
            chipData.push({type: "equalto___handed_over_to_userid", label: handedTo.name, id: handedTo.id})
        }
    }
    if (Filters.boxNumber !== "") {
        chipData.push({type: "boxNumber", label: "Box Number: " + Filters.boxNumber , id: Filters.boxNumber})
    }
    
    //more filters
    if(Filters.null___already_shared_with_these_clients){
        chipData.push({type: "null___already_shared_with_these_clients", label: "Never been part of a collection shared with a client"})
    }
    if(Filters.notnull___shared_with_clientid){
        chipData.push({type: "notnull___shared_with_clientid", label: "shared with a client"})
    }
    if(Filters.equalto___handed_over_to_client){
        chipData.push({type: "equalto___handed_over_to_client", label: "Handed over to a client"})
    }
    if(Filters.equalto___handed_over_to_an_employee_for_internal_use){
        chipData.push({type: "equalto___handed_over_to_an_employee_for_internal_use", label: "Handed over to an employee"})
    }
    if(Filters.null___collection_code){
        chipData.push({type: "null___collection_code", label: "Do not show: Draft & Live collection"})
    }
    if(Filters.notDispatchOrOutOnLoan){
        chipData.push({type: "notDispatchOrOutOnLoan", label: "Do not show: Dispatched & out on loan"})
    }

    // Never liked filter
    if(Filters.neverLiked){
        chipData.push({type: "neverLiked", label: "Never Liked"})
    }

    //sort by
    if (Filters.sortBy && Filters.sortBy !== "-created_at") {
        const sortLabels = {
            '-created_at': 'Newest First',
            '+created_at': 'Oldest First',
            '-cdata.total_likes': 'Most Liked',
            '+cdata.total_likes': 'Least Liked'
        };
        const label = sortLabels[Filters.sortBy] || `Sorted by: ${Filters.sortBy}`;
        chipData.push({type: "sortBy", label: label, id: Filters.sortBy})
    }

    return chipData
}
